module.exports = __webpack_public_path__ + "img/twitter.b308fa8b.svg";